import FillBlanksSeasons from "../../components/UKG/GeneralAwareness/FillBlanksSeasons";
import MatchSeasons from "../../components/UKG/GeneralAwareness/MatchSeasons";
import TrueFalseSeasons from "../../components/UKG/GeneralAwareness/TrueFalseSeasons";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/seasons/choose-correct", title: "Choose Correct", component: FillBlanksSeasons},
    { url: "/ukg/general-awareness/seasons/true-false", title: "True & False", component: TrueFalseSeasons},
    { url: "/ukg/general-awareness/seasons/match-images", title: "Match Seasons", component: MatchSeasons},
];


export default topics;